/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGaugeLed = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.573 12.253c.426.576 1.05.864 1.872.864s1.446-.288 1.872-.864.639-1.416.639-2.52c0-2.202-.837-3.303-2.511-3.303s-2.511 1.101-2.511 3.303c0 1.104.213 1.944.639 2.52zm2.709-.828c-.18.366-.459.549-.837.549s-.657-.183-.837-.549-.27-.93-.27-1.692c0-.75.087-1.296.261-1.638.18-.348.462-.522.846-.522s.663.174.837.522c.18.342.27.888.27 1.638 0 .762-.09 1.326-.27 1.692zM8.587 10.23V15H10V8.547h-.999L7.093 9.906v.828z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgGaugeLed as GaugeLed };
